/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
import React, {
  useContext,
  createContext,
  useState,
  useCallback,
  useEffect,
} from 'react';
import { getStorege, saveStorege } from '../../helpers/db_storage';
import { api } from '../../services';
import { useLoadingContext } from '../use-loading';
import { coordinates } from '../../helpers/utils/locationCoordinates';

interface IShop {
  idMarketplace: number;
  idRestaurante: number;
}

type IData = {
  shop?: IShop | any;
  menu?: any;
  promocao?: any;
  menuSubCategory?: any;
  listMenuItem?: any;
  return?: any;
  signedLoading?: boolean;
  msgError?: string;
  statusCode?: number;
};

type IShopContext = {
  data: IData;
  dataProductsSearch: any;
  dataSubCategoriesSearch: any;
  getDataShop(id_person: IShop | any): Promise<void>;
  setSubCategoryMenu(subCategoryData: any): Promise<void>;
  setProductsSearch(params: any): Promise<void>;
  setSubCategoriesSearch(params: any): Promise<void>;
  listMenuItensShop(subCategoryData: any): Promise<void>;
};
const ShopContext = createContext<Partial<IShopContext>>({});

export const UserShopProvider = ({ children }: any) => {
  const { createloading } = useLoadingContext();

  const [data, setData] = useState<IData>({
    signedLoading: false,
    return: '',
    shop: null,
    menu: null,
    promocao: null,
    menuSubCategory: null,
    listMenuItem: null,
    msgError: '',
    statusCode: 0,
  });

  const [dataProductsSearch, setDataProductsSearch] = useState<any>();
  const [dataSubCategoriesSearch, setDataSubCategoriesSearch] = useState<any>();

  const dataUserMemory = useCallback(() => {
    return new Promise((resolve) => {
      const dataShopStorage = JSON.parse(
        localStorage.getItem('@mais/delivery/shop') as string,
      );
      const dataMenuStorage = JSON.parse(
        localStorage.getItem('@mais/delivery/shop/menu') as string,
      );

      const dataSubCategoryStorage = JSON.parse(
        localStorage.getItem('@mais/delivery/Shops/Menu/SubCategory') as string,
      );

      if (dataShopStorage) {
        setData({
          shop: dataShopStorage,
          menu: dataMenuStorage,
          menuSubCategory: dataSubCategoryStorage,
        });
      }
      resolve(true);
    });
  }, []);

  useEffect(() => {
    (async () => {
      await dataUserMemory();
    })();
  }, []);

  const getDataShop = async (Params: any) => {
    createloading(true);
    const dataLocation = getStorege('@mais/delivery/dataStateCity');

    localStorage.setItem('@mais/delivery/dataStateCity', 'null');
    try {
      let positonLocation;
      if (
        dataLocation !== null &&
        typeof dataLocation === 'object' &&
        dataLocation.lat === '' &&
        dataLocation.lng === ''
      ) {
        positonLocation = await coordinates();
      } else {
        positonLocation = dataLocation;
      }

      const getData: any = await api.apiMaisdelivery.shop.getShop(Params);
      setData({
        shop: getData?.data?.restaurante,
        menu: getData?.data?.cardapio,
        promocao: getData?.data?.promocao,
        return: getData.data.retorno,
        msgError: getData.data.mensagem,
      });

      localStorage.setItem(
        '@mais/delivery/dataStateCity',
        JSON.stringify({
          dsCidade: getData?.data?.restaurante.dsCidade,
          idMarketplace: getData?.data?.restaurante.idMarketplace,
          idCidade: getData?.data?.restaurante.idCidade,
          idEstado: '',
          lat: positonLocation?.lat,
          lng: positonLocation?.lng,
        }),
      );

      localStorage.setItem(
        '@mais/delivery/shop',
        JSON.stringify(getData?.data?.restaurante),
      );
      localStorage.setItem(
        '@mais/delivery/shop/menu',
        JSON.stringify(getData?.data?.cardapio),
      );
      createloading(false);
    } catch (error: any) {
      createloading(false);
      setData({
        signedLoading: false,
        msgError: error,
      });
    }
  };

  const listMenuItensShop = async (Params: any) => {
    createloading(true);
    try {
      const getData: any = await api.apiMaisdelivery.shop.getMenuItensShop(
        Params,
      );

      setData((field: any) => {
        return {
          ...field,
          listMenuItem: getData?.data,
        };
      });

      createloading(false);
    } catch (error: any) {
      createloading(false);
      setData({
        signedLoading: false,
        msgError: error,
      });
    }
  };

  const setSubCategoryMenu = async (subCategoryData: any) => {
    createloading(true);
    saveStorege('@mais/delivery/Shops/Menu/SubCategory', subCategoryData);

    setData((field: any) => {
      return {
        ...field,
        [`menuSubCategory`]: subCategoryData,
      };
    });
    createloading(false);
  };

  const setProductsSearch = async (params: any) => {
    setDataProductsSearch(params);
  };

  const setSubCategoriesSearch = async (params: any) => {
    setDataSubCategoriesSearch(params);
  };

  return (
    <ShopContext.Provider
      value={{
        data,
        dataProductsSearch,
        dataSubCategoriesSearch,
        getDataShop,
        setSubCategoryMenu,
        setProductsSearch,
        setSubCategoriesSearch,
        listMenuItensShop,
      }}
    >
      {children}
    </ShopContext.Provider>
  );
};

export const useShopContext: any = () => {
  return useContext(ShopContext);
};
